class outSystemListCtrl {
    constructor($scope, httpRequest, sweetalert, $state) {
        $scope.listData = []
        $scope.queryParam = {
            pageSize: 10,
            pageNum: 1,
            param: {
                busSysId: '',
                busSysName: '',
            },
        }
        $scope.reset = function () {
            $scope.queryParam.param = {
                busSysId: '',
                busSysName: '',
            }
        }
        $scope.queryList = function queryList() {
            httpRequest.post_querySysBusinessSystemList($scope.queryParam).then((res) => {
                // console.log(res);
                $scope.listData = res.data.value.list
                $scope.totalItem = res.data.value.total
                // console.log($scope.listData );
            })
        }
        $scope.queryList()
        $scope.tableDropdownConfig = [
            {
                label: '编辑',
                showWhile() {
                    return true
                },
                handler(item) {
                    $scope.editSystem(item)
                },
            },
            {
                label: '删除',
                showWhile() {
                    return true
                },
                handler(item) {
                    sweetalert.confirm('操作提醒', '删除后将禁止和该系统进行数据对接，确认删除？').then(() => {
                        httpRequest.post_delSysBusinessSystem(item).then($scope.queryList)
                    })
                },
            },
        ]
        // 新增
        $scope.addSystem = function addSystem() {
            $scope.pageState.addflag = true
            $scope.pageState.system = {}
            console.log($scope.pageState.system)
        }
        // 编辑
        $scope.editSystem = function editSystem(item) {
            $scope.pageState.addflag = false
            for (const key in item) {
                if (item.busStatus == '0') {
                    $scope.pageState.system.busStatus = 0
                }
                $scope.pageState.system[key] = item[key]
            }
            $state.go('system.syssetting.outSystem.edit')
            console.log($scope.pageState.system)
        }
        $scope.f_busStatus = function f_busStatus(busStatus) {
            if (busStatus == 1) {
                return '有效'
            }
            return '无效'
        }
    }
}
outSystemListCtrl.$inject = ['$scope', 'httpRequest', 'sweetalert', '$state']
export default outSystemListCtrl



// WEBPACK FOOTER //
// ./src/app/system/systemsetting/outsystem/outSystemListCtrl.js